<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div class="box-selector" @click="() => toggleIndex()">
      <span>{{ $t('dropdown_index') }}</span>
      <div class="icon-chevron-down" :class="indexOpen ? 'open-header': ''" />
    </div>
    <GrowUpMenu
      v-if="isMobile"
      :mobile-filters-open="indexOpen"
      :show-fixed-buttons="false"
      @toggle-mobile-filter="toggleIndex()"
    >
      <template v-slot:menu-options>
        <div class="index-open">
          <span class="title">{{ $t('index') }}</span>
          <ReportIndex :index-arr="indexArr" @option-selected="() => toggleIndex()" />
        </div>
      </template>
    </GrowUpMenu>
  </div>
</template>

<script>
import ReportIndex from './ReportIndex.vue'
import GrowUpMenu from '../components/mobile/GrowUpMenu.vue'
export default {
  components: { ReportIndex, GrowUpMenu },
  directives: {},
  props: {
    indexArr: {
      type: Array,
    },
  },
  data() {
    return {
      indexOpen: false,
    }
  },
  methods: {
    toggleIndex() {
      this.indexOpen = !this.indexOpen
    }
  }
}
</script>

<style lang="stylus" scoped>
.box-selector
  width: 100%
  border: 1px solid $grey-grey
  display: flex
  justify-content: space-between
  align-items: center
  border-radius: 8px
  padding: vw(6px) vw(10px)
  
  span
    m-font-size(16, 20)
  
  .icon-chevron-down
    m-icon("chevron-down", 18, $grey)
    transform: rotate(0)
    animation: 0.3s

    &.open-header
      transform: rotate(180deg)
      animation-name: rotate
      
.index-open
  padding: vw(15px) vw(10px) vw(10px)
  background-color: #fff
  box-shadow: 0 4px 80px 0 rgba(0, 0, 0, 0.05)
  width: 100%
  display: flex
  flex-direction: column
  gap: vw(10px)
  
  .title
    m-font-size(18, 22)
    font-weight: 600
      
@keyframes rotate
  from
    transform: rotate(0)

  to
    transform: rotate(180deg)
</style>
